/* global G */
/* eslint-disable no-restricted-globals,no-alert,no-unused-vars */
import { curry, setKey } from 'lib/util'
import {
  back,
  bulk,
  edit,
  list,
  persistChange,
  persistCheck,
  persistOption,
  persistOptions,
  redirect,
  submit,
} from '@app/_shared/events'
import { getAttachments, getBreadcrumbs, getNode, getNodeType, getTree, setTree } from 'app/_shared/events/file'
import { jump as jumpBack, list as listBreadcrumbs } from 'app/_shared/events/breadcrumbs'
import search from 'app/_shared/events/search'
import searchDevices from 'app/_shared/events/search/device'
import infinite from 'app/_shared/events/search/infinite'
import createRedirect from 'app/_shared/events/appbar/createRedirect'
import searchAndRecreate from 'app/_shared/events/appbar/searchAndRecreate'
import persistNameOption from 'app/_shared/events/persistNameOption'
import detail from 'app/_shared/events/action/detail'
import debounce from 'app/_shared/events/util/debounce'
import chain from 'app/_shared/events/util/chain'
import { confirm, jump, next, previous } from 'app/_shared/events/step'
import persistSerial from 'app/_shared/events/device/persistSerial'
import missingSerial from 'app/_shared/events/device/missingSerial'
import modelSave from 'app/_shared/events/model/save'
import setStepTab, { CONFIRM, LIST, SEARCH } from 'app/_shared/events/setStepTab'
import searchStepAndRecreate from 'app/_shared/events/searchStepAndRecreate'
import persistCheckAndAction from 'app/_shared/events/combined/persistCheckAndAction'
import listCountries from 'app/_shared/events/collection/listCountries'
import listUserCountries from 'app/_shared/events/collection/listUserCountries'
import listTicketTypes from 'app/_shared/events/collection/listTicketTypes'
import listStatus from 'app/_shared/events/collection/listStatus'
import listTicketStatus from 'app/_shared/events/collection/listTicketStatus'
import listStatusReasons from 'app/_shared/events/collection/listStatusReasons'
import listOrganisationTypes from 'app/_shared/events/collection/listOrganisationTypes'
import link from 'app/_shared/events/link'
import { acl, cell, model } from 'app/_shared/events/acl'
import onKey from 'app/_shared/events/util/onKey'
import menu from 'app/_shared/events/contextmenu'
import { count, item, user } from 'app/_shared/events/pubsub'
import close, { closeModalWith } from 'app/_shared/events/modal/close'
import modelReset from 'app/_shared/events/model/reset'
import modelSet from 'app/_shared/events/model/set'
import sublist from 'app/_shared/events/util/sublist'
import { settings } from 'app/_shared/session'
import action from 'app/_shared/events/action'
import searchWith from 'app/_shared/events/search/with'
import setCountedLabel from 'app/_shared/events/tabs/setCountedLabel'
import searchUnsortedAndRecreate from 'app/_shared/events/appbar/searchUnsortedAndRecreate'
import modelStateSave from 'app/_shared/events/model/stateSave'
import persistStore from 'app/_shared/events/combined/persistStore'
import persistOptionsAndAction from 'app/_shared/events/combined/persistOptionsAndAction'
import hasMultipleFilters from 'app/_shared/events/search/query/hasMultipleFilters'
import searchTree from 'app/_shared/events/search/tree'
import isInName from 'app/_shared/events/search/tree/predicates/isInName'
import remember from 'app/_shared/events/remember'
import persistTab from 'app/_shared/events/tabs/persist'
import getMergedTree from 'app/_shared/events/file/tree/getMergedTree'
import destroyIfNoSubItems from 'app/serviceItem/event/destroyIfNoSubItems'
import searchProduct from 'app/serviceItem/event/searchProduct'
import searchDevice from 'app/serviceItem/event/searchDevice'
import setProduct from 'app/serviceItem/event/setProduct'
import redirectWithItem from 'app/serviceItem/event/redirectWithItem'
// TODO: move to _shared:
import getValidationStatus from 'app/person/event/getValidationStatus'
import updateUnreadMessagesCount from 'app/ticket/event/updateUnreadMessagesCount'
import fromUserOrgs from 'app/_shared/events/search/query/fromUserOrgs'
import join from 'app/_shared/events/search/query/join'
import excludeNotConfirmedForRoles from 'app/_shared/events/search/query/excludeNotConfirmedForRoles'
import getConfirmedStatus from 'app/_shared/events/device/getConfirmedStatus'
import listRequestStatus from 'app/_shared/events/collection/listRequestStatus'
import setListDrawerTitle from 'app/_shared/events/tabs/setListDrawerTitle'
import trimAttachmentName from 'app/equipmentInformation/event/tree/trimAttachmentName'
import displayState from 'app/_shared/events/address/displayState'
import displayHouseNumber from 'app/_shared/events/address/displayHouseNumber'
import update from 'app/_shared/events/util/update'
import listStates from 'app/_shared/events/collection/listStates'
import setItem from 'app/serviceItem/event/setItem'
import selectItem from 'app/serviceItem/event/selectItem'
import { platform } from 'app/_shared/events/util'
import asObject from 'lib/sequence/component/children/asObject'
import setParentNodeOrBack from 'app/_shared/events/file/tree/setParentNodeOrBack'
import { persistUnsaveChange } from 'app/_shared/events/persist/change'
import saveTreeInActionState from 'app/_shared/events/file/tree/saveTreeInActionState'
import updateRequestList from 'app/request/event/updateRequestList'
import { countWithFilter } from 'app/_shared/events/pubsub/countWith'
import reference from 'app/_shared/events/pubsub/reference'
import { withAttributeKey } from 'app/_shared/events/redirect/withModelKey'
import { toggleFavoriteFromModel } from 'app/_shared/events/favorite/toggle'
import { submitModalWith } from 'app/_shared/events/modal/submit'
import focusNext from 'app/_shared/events/field/focusNext'
import dismissKeyboard from 'app/_shared/events/keyboard/dismiss'
import createWithAcl from 'app/_shared/events/appbar/createWithAcl'
import createWithItem from 'app/serviceItem/event/createWithItem'

export default {
  acl: {
    acl,
    cell,
    model,
  },
  onOpen: {
    listing: list('short'),
    listWithRefs: list(null),
    listVerbose: list('verbose'),
    search: search(null),
    searchDevices: searchDevices(null),
    searchVerbose: search('verbose'),
    searchWithFilter: chain(
      searchWith(['filter']),
      search(null),
    ),
    searchWithQuery: chain(
      searchWith(['query']),
      search(null),
    ),
    listCountries,
    link,
    infinite: infinite(null),
    infiniteVerbose: infinite('verbose'),
    infiniteVerboseIfTerm: chain(
      curry((module, component, event) => {
        if (!component[G.STATE]?.[G.META]?.term) {
          throw Error('No term')
        }
      }),
      infinite('verbose'),
    ),
    infiniteVerboseWithFilter: chain(
      searchWith(['filter']),
      infinite('verbose'),
    ),
    infiniteWithRequestCount: infinite('defaultWithRequestCount'),
    infiniteWithRequestCountAndQuery: chain(
      searchWith(['query']),
      infinite('defaultWithRequestCount'),
    ),
    infiniteWithTicketCount: infinite('defaultWithTicketCount'),
    infiniteWithQuery: chain(
      searchWith(['query']),
      infinite(null),
    ),
    getTree,
    getMergedTree,
    getBreadcrumbs,
    setTabSearch: searchWith(['filter']),
    setTabSearchAndSuppressServiceItem: chain(
      searchWith(['filter']),
      curry((module, component, event) => {
        const { list = component } = asObject(component[G.CHILDREN])
        setKey(true, 'suppressServiceItem', list[G.STATE])
      }),
    ),
    setTabSearchAndListDrawerTitle: chain(
      searchWith(['filter']),
      setListDrawerTitle,
    ),
    setListDrawerTitle,
    getValidationStatus,
    getConfirmedStatus,
    listStatus,
    listStates,
    listBreadcrumbs,
    getEquipmentStatus: curry((module, component, event) => {
      const { equipment } = module[G.MODEL][G.CHILDREN]
      const { label } = component[G.PROPS]
      const { t: { label: { options = {} } = {} } = {} } = component[G.CONFIGURATION]

      return !equipment[G.STATE][G.REF] && !settings.suppressEquipmentDevices
        ? [{
          value: module[G.ADAPTER][G.INTL]._t(options._key, { ...options, defaultValue: label }),
          color: 'warning.700',
          backgroundColor: 'warning.50',
        }]
        : []
    }),
  },
  onShowAll: {
    infinite: infinite(null),
    infiniteVerbose: infinite('verbose'),
    infiniteVerboseWithFilter: chain(
      searchWith(['filter']),
      infinite('verbose'),
    ),
  },
  onSubmit: {
    focusNext: focusNext(null),
    searchProduct,
  },
  onTree: {
    setTree,
  },
  onTreeSearch: {
    searchTree: searchTree([
      isInName,
    ]),
  },
  onNode: {
    getNode,
  },
  onNodeType: {
    getNodeType,
  },
  onAttachment: {
    trimAttachmentName,
    getAttachments,
  },
  onBreadcrumbs: {
    getBreadcrumbs,
  },
  onSearch: {
    searchUnsortedAndRecreate,
    searchAndRecreate,
    searchStepAndRecreate,
  },
  onCreate: {
    createRedirect,
    createWithAcl,
    createWithItem,
  },
  onSubscription: {
    reference,
  },
  onPublication: {
    updateRequestList,
    countWithFilter,
  },
  onClose: {
    close,
    redirect,
    back,
    resetFavorite: closeModalWith('favoriteModal'),
  },
  onClick: {
    toggleFavorite: toggleFavoriteFromModel,
    favorite: submitModalWith('submitFavorite'),
    edit,
    redirect,
    redirectWithEquipment: redirectWithItem,
    submit,
    bulk,
    detail,
    back,
    jump,
    jumpBack,
    next,
    confirmStep: chain(
      confirm,
      next,
    ),
    missingSerial,
    searchProduct: chain(
      platform({ mobile: dismissKeyboard }),
      searchProduct,
    ),
    setProduct,
    setLocation: chain(
      modelSet('installedAt'),
      modelStateSave('installedAt'),
      setStepTab(CONFIRM),
      platform({
        mobile: chain(
          confirm,
          next,
        ),
      }),
    ),
    unsetItem: chain(
      modelReset(),
      setStepTab(SEARCH),
    ),
    unsetLocation: chain(
      modelReset('installedAt'),
      setStepTab(SEARCH),
    ),
    saveLocation: modelSave('installedAt'),
    redirectToTicketWith: redirectWithItem,
    redirectToRequestWith: redirectWithItem,
    toList: setStepTab(LIST),
    toConfirm: setStepTab(CONFIRM),
    toSearch: setStepTab(SEARCH),
    /**
     * Fired whenever the user clicks on the button "I still want to register the device".
     *
     * If the user has the suppressProductDevices setting, redirects them to the device confirmation
     * tab, otherwise it redirects them to the product selection tab.
     *
     * @type {Gaia.AppModule.EventHandler}
     */
    registerDevice: curry((module, component, event) => {
      const tab = settings.suppressProductDevices ? CONFIRM : LIST
      setStepTab(tab)(module, component, event)
    }),
    destroyIfNoSubItems,
    setItem: chain(
      setItem,
      action,
    ),
    selectItem,
    redirectToLocation: withAttributeKey('installedAt'),
  },
  onBack: {
    setParentNodeOrBack,
    previous,
  },
  onChange: {
    unsavePersistTreeAndRemember: chain(
      persistUnsaveChange,
      saveTreeInActionState,
      remember,
    ),
    persistNameOption,
    persistChange,
    persistOptions,
    persistOptionsAndAction,
    persistOption,
    persistStore,
    persistCheck,
    persistCheckAndAction,
    persistCountry: curry(async (module, component, componentInfo, attributeInfo, event) => await chain(
      persistOptions,
      displayState('state', 'country', componentInfo, attributeInfo),
      displayHouseNumber('number', 'street', componentInfo, attributeInfo),
      update,
    )(module, component, event)),
    persistStates: persistOptions,
    persistSerial,
    searchDevice: debounce(chain(
      persistChange,
      searchDevice,
    ), 1000),
    persistTabAndRemember: chain(
      persistTab,
      remember,
      platform({
        mobile: update,
      }),
    ),
    persistOptionsRememberAndAction: chain(
      persistOptions,
      remember,
      action,
    ),
    persistCheckRememberAndAction: chain(
      persistCheck,
      remember,
      action,
    ),
  },
  onBlur: {
    searchSerial: searchDevice,
  },
  onKeyPress: {
    searchProduct: onKey('Enter', searchProduct),
    searchSerial: onKey('Enter', searchDevice),
  },
  onAction: {
    redirect,
  },
  list: {
    sub: user,
  },
  item: {
    sub: item,
  },
  cell: {
    sub: updateUnreadMessagesCount,
  },
  count: {
    sub: count,
  },
  onContextMenu: {
    menu: menu(null),
  },
  onPage: {
    remember,
  },
  onLinkChange: {
    setLink: link,
  },
  getOrganisationType: {
    listOrganisationTypes,
  },
  getTicketType: {
    listTicketTypes,
  },
  getStatus: {
    listTicketStatus,
    listRequestStatus,
    listStatus,
  },
  getStatusReason: {
    listStatusReasons,
  },
  getSelection: {
    listOrganisationTypes: sublist(
      ['customer', 'independent_contractor', 'internal', 'partner'],
      listOrganisationTypes,
    ),
    listUserCountries,
  },
  getLabel: {
    setReqLabel: setCountedLabel({ ns: 'ticket', key: 'requests' }),
    setCsmLabel: setCountedLabel({ ns: 'ticket', key: 'tickets' }),
    listOrganisationTypes,
  },
  filter: {
    serviceItem: curry((module, component, event) => ({
      item: module[G.MODEL][G.STATE][G.REF],
    })),
    isSolved: curry((module, component, event) => ({
      status: { min: 80 },
    })),
    hasItemAndIsOpen: curry((module, component, event) => ({
      item: module[G.MODEL][G.STATE][G.REF],
      status: { max: 79 },
    })),
    hasItemAndIsSolved: curry((module, component, event) => ({
      item: module[G.MODEL][G.STATE][G.REF],
      status: { min: 80 },
    })),
    isNotInactive: curry((module, component, event) => ({
      status: { max: 79 },
    })),
    isActiveAndNotMyself: curry((module, component, event) => ({
      status: 50,
      id: `!${module[G.MODEL][G.STATE][G.REF]}`,
    })),
    isActiveAndProvidesSupport: curry((module, component, event) => ({
      status: 50,
      support_provides: true,
    })),
  },
  query: {
    serviceitemHasStatusAndToBeValidated: hasMultipleFilters('serviceitem', ['status', 'toBeValidated']),
    userOrgsAsInstalledAtOrInstalledAt: join(
      fromUserOrgs('installedAt', 'installedAt'),
      excludeNotConfirmedForRoles,
    ),
    userOrgsAsParentOrId: fromUserOrgs('parent', 'id'),
  },
}
